import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
const API_LOCAL = process.env.VUE_APP_API_URL_LOCAL;

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

export default {
  obtenerCabecera(idUsuario) {
    return axios.get(`${API_URL}/Alumnos/v1/ObtenerContrato`, { params: { id_usuario: idUsuario } });
  },

  obtenerDetalle(idUsuario) {
    return axios.get(`${API_URL}/Alumnos/v1/ObtenerContratoDetalle`, { params: { id_usuario: idUsuario } });
  },

  crearActualizarContrato(payload) {
    return axios.post(`${API_LOCAL}/v2/save/alumno/contrato/crear-actualizar`, payload, { headers: authHeaders() });
  },

  actualizarCabecera(payload) {
    return axios.put(`${API_LOCAL}/v2/save/alumno/contrato/cabecera`, payload, { headers: authHeaders() });
  },

  actualizarDetalleItem(payload) {
    return axios.put(`${API_LOCAL}/v2/save/alumno/contrato-detalle/item`, payload, { headers: authHeaders() });
  },

  /** Promoción de curso (uno o varios alumnos). */
  promoverCurso(payload) {
    return axios.post(`${API_LOCAL}/v2/save/alumno/curso`, payload, { headers: authHeaders() });
  },
};
